import { Flex, Typography } from 'front-commons/ds';
import { AccordionContent } from './AccordionContent';
import { AccordionsProps } from './interfaces';
import { Item, Root, Trigger } from './styles';
import { Icon } from 'hype-ds';

export function Accordions({ filters, handleSelectedFilters }: AccordionsProps) {
	return (
		<Root type="single" collapsible>
			{filters?.map((filter) => (
				<Item value={filter.name}>
					<Trigger>
						<Flex gap="0.5rem">
							<Typography variant="Paragraph/Semibold">{filter.title}</Typography>

							<Typography variant="Paragraph/Regular" color="--text-secondary">
								({filter.options.length})
							</Typography>
						</Flex>

						<Icon name="chevron_right" size="24px" color="--text-link" />
					</Trigger>

					<AccordionContent filter={filter} handleSelectedFilters={handleSelectedFilters} />
				</Item>
			))}
		</Root>
	);
}
